import Link from 'next/link';
import React from 'react';

import classNames from 'classnames';

import type { TSailingPortDetail } from '@/infra/types/voyageInfo/port';

import { useUIResourcePool } from '@/ducks/common/resources';

import styles from './TenderPortsNote.module.scss';

type TTenderPortsNoteProps = {
  className?: string;
  sailingPortDetails?: TSailingPortDetail[];
};

const UI_RESOURCES_POOL = {
  description: 'Precheckout.tenderPort.noteToSailors.description',
  headline: 'Precheckout.tenderPort.noteToSailors.headline',
  learnMore: 'Precheckout.tenderPort.learnMore',
} as const;

const TenderPortsNote = ({ className, sailingPortDetails }: TTenderPortsNoteProps) => {
  const { description, headline, learnMore } = useUIResourcePool(UI_RESOURCES_POOL);
  const hasTenderPorts = sailingPortDetails?.some((port) => port.dayType === 'tender');
  const tenderPortWithLearnMore = sailingPortDetails?.find((port) => port.learnMoreLink);

  if (!hasTenderPorts) {
    return null;
  }

  return (
    <div className={classNames(styles.tenderNote, className)}>
      <h4 className={styles.tenderNoteHeadline}>{headline}</h4>
      <p className={styles.tenderNoteDescription}>
        {description}
        {tenderPortWithLearnMore?.learnMoreLink?.href && (
          <Link
            className={styles.tenderNoteLearnMore}
            href={tenderPortWithLearnMore.learnMoreLink.href}
            prefetch={false}
            rel="noopener noreferrer"
            target="_blank"
          >
            {tenderPortWithLearnMore.learnMoreLink.text || learnMore}
          </Link>
        )}
      </p>
    </div>
  );
};

export default TenderPortsNote;
